import React from 'react'
import { Box } from '@chakra-ui/react'
import { AuthorizationEventResolutionCreateButton } from './AuthorizationEventResolutionCreateButton/AuthorizationEventResolutionCreateButton'

interface Props {
  refetch: () => Promise<unknown>
}

export const Actions: React.FC<Props> = ({ refetch }) => {
  return (
    <Box>
      <AuthorizationEventResolutionCreateButton refetch={refetch} />
    </Box>
  )
}
